/**
 * Read the `exp` claim from a JWT without verifying it. Used only to schedule a
 * proactive refresh; the backend still validates every token it receives.
 */
export function getJwtExpiryMs(token: string | null | undefined): number | null {
	if (!token) return null;
	const parts = token.split(".");
	if (parts.length !== 3) return null;

	try {
		const base64 = parts[1].replace(/-/g, "+").replace(/_/g, "/");
		const padded = base64 + "=".repeat((4 - (base64.length % 4)) % 4);
		const payload: unknown = JSON.parse(atob(padded));
		const exp = (payload as { exp?: unknown } | null)?.exp;
		return typeof exp === "number" && Number.isFinite(exp) ? exp * 1000 : null;
	} catch {
		return null;
	}
}
